module.exports = __webpack_public_path__ + "img/pets2.85fe770d.svg";